import { forwardRef, useState } from 'react';
import { TextInput, TextInputProps } from './TextInput';
import { IconName } from '@ardoq/icons';
import { DEFAULT_ARDOQ_I18NLOCALE, t } from '@ardoq/i18n';

export type PasswordInputProps = Omit<
  TextInputProps,
  'type' | 'rightIconName' | 'rightIconOnClick' | 'rightIconTooltip'
>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ i18nLocale = DEFAULT_ARDOQ_I18NLOCALE, ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisible = () => setIsVisible(!isVisible);

    return (
      <TextInput
        ref={ref}
        type={isVisible ? 'text' : 'password'}
        rightIconName={
          isVisible ? IconName.VISIBILITY_OFF : IconName.VISIBILITY
        }
        rightIconOnClick={toggleVisible}
        rightIconTooltip={
          isVisible
            ? t(i18nLocale, 'forms:passwordInput.hideTooltip', 'Hide')
            : t(i18nLocale, 'forms:passwordInput.showTooltip', 'Show')
        }
        i18nLocale={i18nLocale}
        {...props}
      />
    );
  }
);
